<template>
  <div class="text-right">
    <v-dialog v-model="dialog" width="600" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          elevation="0"
          v-bind="attrs"
          v-on="on"
          class="small-text ma-2 ms-0 me-0 send-btn"
        >
          <v-icon right dark class="ml-1">
            mdi-account-multiple-plus-outline
          </v-icon>
          <span>إضافة مستخدم جديد</span>
        </v-btn>
      </template>
      <v-form ref="addNewUserForm" v-model="valid" lazy-validation>
        <v-card class="text-right">
          <v-alert dense text type="success" v-if="successAlert" class="small-text">
            تمت إضافة المستخدم <strong>بنجاح</strong>
          </v-alert>

          <v-alert
            dense
            text
            type="error"
            v-if="validationErrors.length"
            class="small-text"
          >
            <div v-for="(message, index) in validationErrors" :key="index">
              {{ message }}
            </div>
          </v-alert>

          <v-alert dense text type="error" v-if="errorAlert" class="small-text">
            فشل في العملية الرجاء اعادة المحاولة
          </v-alert>

          <v-card-text class="mt-3">
            الرجاء مليء معلومات المستخدم الجديد لغرض إنشاء الحساب
          </v-card-text>

          <v-divider></v-divider>

          <v-container>
            <h6>الاسم</h6>
            <v-text-field
              placeholder="الاسم الكامل"
              outlined
              dense
              :rules="requiredRule"
              v-model="form.name"
              class="mt-2"
            ></v-text-field>

            <h6>اسم المستخدم</h6>
            <v-text-field
              placeholder="Username"
              outlined
              dense
              :rules="requiredRule"
              v-model="form.username"
              class="mt-2 eng-text"
            ></v-text-field>

            <h6>رقم الموبايل</h6>
            <v-text-field
              placeholder="07XXXXXXXXX"
              outlined
              dense
              :rules="mobileRule"
              v-model="form.mobile"
              class="mt-2 eng-text"
            ></v-text-field>

            <h6>كلمة المرور</h6>
            <v-text-field
              type="password"
              placeholder="Password"
              outlined
              dense
              :rules="passwordRule"
              v-model="form.password"
              class="mt-2 eng-text"
            ></v-text-field>

            <h6>الصلاحية</h6>
            <v-select
              :items="roles"
              item-text="text"
              item-value="value"
              placeholder="اختر الصلاحية"
              outlined
              dense
              :rules="requiredRule"
              v-model="form.role"
              class="mt-2"
            ></v-select>
          </v-container>

          <v-card-actions>
            <v-btn
              class="send-btn small-text"
              text
              :loading="saving"
              :disabled="saving"
              @click="addUserFunction"
            >
              إضافة المستخدم
            </v-btn>
            <v-btn class="outlined small-text" text @click="closeDialog">
              الغاء
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AddNewUser",

  data() {
    return {
      dialog: false,
      saving: false,
      valid: false,
      successAlert: false,
      errorAlert: false,
      validationErrors: [],
      requiredRule: [(v) => !!v || "هذا الحقل مطلوب"],
      mobileRule: [
        (v) => !!v || "هذا الحقل مطلوب",
        (v) => /^[0-9]{11}$/.test(v || "") || "رقم الموبايل يجب ان يتكون من 11 رقم",
      ],
      passwordRule: [
        (v) => !!v || "هذا الحقل مطلوب",
        (v) => (v || "").length >= 8 || "كلمة المرور يجب ان لا تقل عن 8 خانات",
      ],
      roles: [
        { text: "مستخدم", value: "client" },
        { text: "ناشر", value: "publisher" },
      ],
      form: {
        name: "",
        username: "",
        mobile: "",
        password: "",
        role: "",
      },
    };
  },

  methods: {
    ...mapActions(["createUser"]),

    resetAlerts() {
      this.successAlert = false;
      this.errorAlert = false;
      this.validationErrors = [];
    },

    closeDialog() {
      this.resetAlerts();
      this.dialog = false;
      this.$refs.addNewUserForm.reset();
      this.valid = false;
    },

    addUserFunction() {
      this.resetAlerts();
      if (!this.$refs.addNewUserForm.validate()) return;

      this.saving = true;
      this.createUser({ ...this.form })
        .then(() => {
          this.saving = false;
          this.successAlert = true;
          this.$emit("user-added");
          setTimeout(() => {
            this.closeDialog();
          }, 2000);
        })
        .catch((error) => {
          this.saving = false;
          const errors =
            error.response && error.response.data && error.response.data.errors;
          if (errors) {
            this.validationErrors = this.translateErrors(errors);
          } else {
            this.errorAlert = true;
          }
        });
    },

    translateErrors(errors) {
      const messages = [];
      if (errors.username) messages.push("اسم المستخدم مستعمل مسبقاً");
      if (errors.mobile) messages.push("رقم الموبايل مستعمل مسبقاً");
      if (errors.role) messages.push("الصلاحية المختارة غير مسموح بها");
      if (errors.name) messages.push("حقل الاسم مطلوب");
      if (errors.password)
        messages.push("كلمة المرور مطلوبة ويجب ان لا تقل عن 8 خانات");
      return messages.length ? messages : ["فشل في العملية الرجاء اعادة المحاولة"];
    },
  },
};
</script>

<style scoped>
.eng-text {
  direction: ltr;
}
</style>
